import * as pxp from '../lib/pxp'

/**
 * Show new success page only for treatment
 * @returns {boolean}
 */
export function shouldShowSuccessSendMoneySurvey() {
  return pxp.isTreatment('Trmt_p2p_send_money_success_survey')
}

/**
 * Show a different design for the qualtrics survey
 * @returns {boolean}
 */
export function shouldShowAlternativeSuccessMessage() {
  return pxp.isTreatment('Trmt_p2p_send_money_success_survey_2')
}
